var map = {
	"./symbol_0.png": 49323,
	"./symbol_1.png": 28194,
	"./symbol_2.png": 76377,
	"./symbol_3.png": 79472,
	"./symbol_4.png": 22319,
	"./symbol_5.png": 83302,
	"./symbol_6.png": 24541,
	"./symbol_7.png": 3412,
	"./symbol_8.png": 29331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58702;